import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, EMPTY, Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { EstadoCuentaInterface } from 'src/app/Model/Afiliados/estadoAfiliado';
import { DatosGeneralesInterface } from 'src/app/Model/Afiliados/generales';
import { DataApi } from 'src/app/Model/dataApi';
import { DataApiService } from 'src/app/services/data-api.service';
import { ToastrServiceLocal } from 'src/app/services/toast/toastr.service';
import { MensajesHttpService } from 'src/app/utils/mensajesHttp/mensajes-http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EstadoCuentaFacadeService {

  constructor(public _toast: ToastrServiceLocal, public _dataApi: DataApiService,
    public _mensajesHttp: MensajesHttpService) { };

  private Cargando$ = new BehaviorSubject<boolean>(false);
  public responseCargando$: Observable<boolean> = this.Cargando$.asObservable();

  private EstadoCuenta$ = new BehaviorSubject<EstadoCuentaInterface>({});
  public responseEstadoCuenta$: Observable<EstadoCuentaInterface> = this.EstadoCuenta$.asObservable();

  private DatosGenerales$ = new BehaviorSubject<DatosGeneralesInterface>({});
  public responseDatosGenerales$: Observable<DatosGeneralesInterface> = this.DatosGenerales$.asObservable();
  
  private PagosPendientes$ = new BehaviorSubject<any>([]);
  public responsePagosPendientes$: Observable<any> = this.PagosPendientes$.asObservable();

  mostrarEstadoCuenta(params?: any, idAfiliado: any = environment.idAfiliado) {
    this.Cargando$.next(true);

    const request$ = this._dataApi.GetDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${idAfiliado}/estadodecuenta`, params,  8).pipe(
      tap((result: DataApi | any) => {
        if(result.hasError === false){
          this.EstadoCuenta$.next(result?.data);
        }
        this.Cargando$.next(false);
      }),
      catchError((error: HttpErrorResponse) => {
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrió un error al mostrar el estado de cuenta', '');
        this.Cargando$.next(false);
        return EMPTY;
      })
    );
    return request$.subscribe();
  }

  mostrarDatosGenerales(params?: any) {
    this.Cargando$.next(true);
   
    const request$ = this._dataApi.GetDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${environment.idAfiliado}/detalle`, params,  8).pipe(
      tap((result: DataApi | any) => {
        if(result.hasError === false){
          this.DatosGenerales$.next(result?.data);
        }
        this.Cargando$.next(false);
      }),
      catchError((error: HttpErrorResponse) => {
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrió un error al mostrar los datos generales', '');
        this.Cargando$.next(false);
        return EMPTY;
      })
    );
    return request$.subscribe();
  }

  mostrarPagosPendientes(params: any, callback) {
    this.Cargando$.next(true);
    //  const request$ = this._dataApi.GetDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/afiliado/${params.idAfiliado}/pagospendientes`, '', 8).pipe(
    const request$ = this._dataApi.GetDataApi(`${environment.site}/api/afiliados/${environment.processEnv}/v1/pagos/pendientes`,'',  8).pipe(
      tap((result: DataApi | any) => {
        if(result?.data.table0){
          callback(result.data.table0);
        }
        this.Cargando$.next(false);
      }),
      catchError((error: HttpErrorResponse) => {
        callback([]);
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrió un error al mostrar los pagos pendientes', '');
        this.Cargando$.next(false);
        return EMPTY;
      })
    );
    return request$.subscribe();
  }

  mostrarCargando(){
    this._toast.mensajeLoading('Cargando', 'Procesando la información');
  }
  cerrarCargando(){
    this._toast.clearToasts();

  }
  
}
